import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-share-after',
  templateUrl: './share-after.component.html',
  styleUrls: ['./share-after.component.scss']
})
export class ShareAfterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
